import { Component, PureComponent, useState } from "react";

class SwitchToggle extends PureComponent {
    render() {
        const { styles, classNames } = this.props;
        return (
            <div className={classNames?.parentDiv} style={styles?.parentDiv}>
                <label class={classNames?.label} style={styles?.label}>
                    <input className={classNames?.input} type="checkbox" style={styles?.input} />
                    <div
                        class={classNames?.sliderDiv}
                        style={styles?.sliderDiv}
                        onClick={() => this.props.setSwitch()}>
                        <div
                            className={classNames?.sliderSwitch}
                            style={styles?.sliderSwitch}></div>
                    </div>
                </label>
            </div>
        );
    }
}

export default SwitchToggle;
